import { Controller } from "stimulus";
import $script from 'scriptjs';

export default class RecaptchaController extends Controller {
  /* eslint-disable no-undef */
  connect() {
    window.recaptchaCallback = this.recaptchaCallback;

    if (typeof grecaptcha !== 'undefined') {
      recaptchaCallback();
    } else {
      $script('https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit');
    }

  }

  recaptchaCallback = () => {
    grecaptcha.render(this.element, {
      'sitekey' : process.env.RECAPTCHA_SITE_KEY
    });

    window.onresize = () => {
      this.rescaleCaptcha();
    }

    this.rescaleCaptcha();
  }

  rescaleCaptcha() {
    const width = this.element.parentNode.clientWidth;
    let scale;

    if (width < 302) {
      scale = width / 302;
    } else {
      scale = 1.0;
    }

    this.element.style.transform = `scale(${scale })`;
    this.element.style.transformOrigin = '0 0';
  }
  /* eslint-enable no-undef */
}
